export enum PhotoDrawerSortingOptions {
  SHOT_MOST_RECENT,
  SHOT_LESS_RECENT,
  UPLOAD_MOST_RECENT,
  UPLOAD_LESS_RECENT,
  NAME_ALPHABETIC,
  NAME_ALPHABETIC_REVERSE,
}
